<div id="webHooks" class="pl-5 pr-4 mt-5 pt-5 pb-3" style="background-color: HSL(225, 40%, 98%);">
    <app-header title="Endpoints"></app-header>

    <header>
        <div class="d-flex align-items-center justify-content-between mb-2">
            <div class="headline-4">Webhook Endpoints</div>
            <div class="d-flex align-items-center">
                <button (click)="addWebHook()" id="addNewWebHook" class="btn btn--paybee btn-sm modal-confirm-button">Add new webhook endpoint...</button>
            </div>
        </div>
        <span class="grey-text subtitle-1">View and edit webhook endpoints for this account</span>
    </header>
</div>

<div class="py-5 pl-5 pr-4">
        @for(webhook of webHookList; track webhook.id){
            <app-webhook-card [webHook] = "webhook"></app-webhook-card>
        } @empty {
            <div class="text-center p-3">No webhooks yet!</div>
        }
</div>